import React, {
  createContext,
  ReactNode,
  useContext,
  useState,
  useEffect
} from 'react'
import { useLocation } from 'react-router-dom'

type MenuLateralContextProps = {
  onMenuLateralClose: () => void
  itemSelecionado: string
  setItemSelecionado: (valor: string) => void
  persistirMenus: string[]
  setPersistirMenus: (menu: string[]) => void
}

type MenuLateralProviderProps = {
  children: ReactNode
  onMenuLateralClose: () => void
}

const MenuLateralContext = createContext({} as MenuLateralContextProps)

const MenuLateralProvider = ({
  children,
  onMenuLateralClose
}: MenuLateralProviderProps) => {
  const [itemSelecionado, setItemSelecionado] = useState('/')
  const [persistirMenus, setPersistirMenus] = useState([''])
  const location = useLocation()

  useEffect(() => {
    setItemSelecionado(location.pathname)
  }, [location])

  return (
    <MenuLateralContext.Provider
      value={{
        onMenuLateralClose,
        itemSelecionado,
        setItemSelecionado,
        persistirMenus,
        setPersistirMenus
      }}
    >
      {children}
    </MenuLateralContext.Provider>
  )
}

const useMenuLateral = () => {
  const context = useContext(MenuLateralContext)

  return context
}

export { MenuLateralProvider, useMenuLateral }
